import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import JuridicalPerson from 'src/entities/JuridicalPerson';
import ProfileCardComponent, { ProfileCardComponentProps } from './ProfileCard.component';
import { history } from 'src/store';

interface State {
  profileId: number;
  name?: string;
  juridical: boolean;
  isDefaultProfile: boolean;
}

interface StateProps {
  juridicalPerson?: JuridicalPerson;
}

interface DispatchProps {
}

interface Props extends StateProps, DispatchProps, State {
}

class ProfileCardContainer extends React.Component<Props> {

  public render(): React.ReactNode {
    return (
      <ProfileCardComponent {...this.getComponentProps()} />
    );
  }

  private handleEdit = () => {

    if (this.props.juridical) {
      history.push('/mi-cuenta/perfil/juridico/editar/' + this.props.profileId);
    } else {
      history.push('/mi-cuenta/perfil/fisico/editar');
    }
  }

  private getComponentProps(): ProfileCardComponentProps {
    return {
      id: this.props.profileId,
      name: this.props.name,
      juridical: this.props.juridical,
      isDefaultProfile: this.props.isDefaultProfile,
      handleEdit: () => this.handleEdit(),
    };
  }

}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => {

  return {};
};

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  juridicalPerson: state.getJuridicalPerson.juridicalPerson
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileCardContainer);



// WEBPACK FOOTER //
// ./src/modules/my-account/my-profile-index/partials/ProfileCard.container.tsx